import actionTypes from '../actionTypes';

export const getTeamMembers = (teamId) => ({
  type: actionTypes.MEMBERS_GET_REQUEST,
  teamId,
});

export const setTeamMembers = (members) => ({
  type: actionTypes.MEMBERS_SET,
  members,
});

export const addTeamMember = (member) => ({
  type: actionTypes.MEMBER_ADD,
  member,
});

export const saveTeamMember = (member) => ({
  type: actionTypes.MEMBER_SAVE,
  member,
});

export const removeTeamMember = (member) => ({
  type: actionTypes.MEMBER_REMOVE,
  member,
});

export const createTeamMember = (member) => ({
  type: actionTypes.MEMBER_CREATE_REQUEST,
  member,
});

export const updateTeamMember = (member) => ({
  type: actionTypes.MEMBER_UPDATE_REQUEST,
  member,
});

export const deleteTeamMember = (member) => ({
  type: actionTypes.MEMBER_DELETE_REQUEST,
  member,
});

export const createMemberOwnership = (ownership) => ({
  type: actionTypes.OWNERSHIP_CREATE_REQUEST,
  ownership,
});

export const updateMemberOwnership = (ownership) => ({
  type: actionTypes.OWNERSHIP_UPDATE_REQUEST,
  ownership,
});

export const deleteMemberOwnership = (ownership) => ({
  type: actionTypes.OWNERSHIP_DELETE_REQUEST,
  ownership,
});

export const updateUser = (user) => ({
  type: actionTypes.USER_UPDATE_REQUEST,
  user,
});

export const getUser = (userId) => ({
  type: actionTypes.USER_GET_REQUEST,
  userId,
});

export const getUsersWithReferrerID = (referrer) => ({
  type: actionTypes.USERS_WITH_REFERRER_ID_GET_REQUEST,
  referrer,
});



// WEBPACK FOOTER //
// src/redux/actions/users.js